import React, { useCallback } from 'react';

interface PageIndicatorProps {
  pageNumber: number;
  currentPage: number;

  onPageSelected: (pageNumber: number) => void;
}

export const PageIndicator = (props: PageIndicatorProps) => {
  const { currentPage, pageNumber, onPageSelected } = props;

  const onClick = useCallback(() => onPageSelected(pageNumber), [pageNumber, onPageSelected]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onClick();
      }
    },
    [onClick]
  );

  return (
    <span
      key={pageNumber}
      className={`page-indicator page-number${currentPage === pageNumber ? ' current' : ''}`}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}>
      {pageNumber}
    </span>
  );
};
